import React from "react";
import * as twitterText from "twitter-text";
import { getNetworkLimits } from "../../utils/Helpers";
interface ISocialLimitsProps {
    client?: Mongo.IClient;
    url?: string;
    comment?: string;
    addedImage?: boolean;
    image?: string;
    sURLDomain: string;
    hasArticleLink?: boolean;
}
const SocialLimits = (props: ISocialLimitsProps) => {
    const { client, url, comment, addedImage, image, sURLDomain, hasArticleLink } = props;
    const networkLimits = getNetworkLimits();
    const renderSocialLimits = (social: "Facebook" | "IG" | "LinkedIn" | "Twitter", maxLength: number, length: number) => {
        if (!checkSocialNetworks(social)) {
            return [];
        }
        var isExceeding = length > maxLength;
        return [
            <span style={{ color: isExceeding ? 'red' : 'inherit' }}>
                {social === 'Twitter' ? 'X (Twitter)' : social} (<span>{maxLength - length})</span>
            </span>
        ];
    };
    const checkSocialNetworks = (socialNetwork: "Facebook" | "IG" | "LinkedIn" | "Twitter") => {
        if (client && client.socialNetworks?.[socialNetwork]?.available) {
            return true;
        }
        return false;
    };

    return (

        comment ? (
            <span
                style={{
                    marginLeft: "auto"
                }}
            >
                {[
                    ...(renderSocialLimits(
                        "Facebook",
                        networkLimits.facebook.commentCharacters,
                        comment.length
                    ) || []),
                    ...(checkSocialNetworks("Facebook") && checkSocialNetworks("IG")
                        ? " | "
                        : []),
                    ...(renderSocialLimits(
                        "IG",
                        networkLimits.instagram.commentCharacters,
                        comment.length
                    ) || []),
                    ...((checkSocialNetworks("Facebook") || checkSocialNetworks("IG")) &&
                        checkSocialNetworks("LinkedIn")
                        ? " | "
                        : []),
                    ...(renderSocialLimits(
                        "LinkedIn",
                        networkLimits.linkedIn.commentCharacters - (addedImage && image && url ? (sURLDomain.length + 7) : 0),
                        comment.length
                    ) || []),
                    ...((checkSocialNetworks("Facebook") || checkSocialNetworks("IG") || checkSocialNetworks("LinkedIn")) &&
                        checkSocialNetworks("Twitter")
                        ? " | "
                        : []),
                    ...(renderSocialLimits(
                        "Twitter",
                        networkLimits.twitter.commentCharacters - (hasArticleLink ? 24 : 0),
                        twitterText.parseTweet(comment).weightedLength
                    ) || [])
                ]}
            </span>
        ) : <span></span>
    );
};
export default SocialLimits;
